import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import useCountUp from '../../utils/useCountUp';
import './StartPage2.scss';
// import { initializeApp } from 'firebase/app';
// import { getFirestore, collection, getDocs } from 'firebase/firestore';

const StartPage2 = () => {
	const navigate = useNavigate();
	const [visitorsCount] = useState(0);

	// const firebaseConfig = {
	// 	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	// 	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	// 	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	// 	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	// 	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	// 	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	// 	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
	// };

	// // Initialize Firebase
	// const app = initializeApp(firebaseConfig);
	// const firestore = getFirestore(app);

	// useEffect(() => {
	// 	const visitRef = collection(firestore, 'visits');

	// 방문자 수 실시간 업데이트
	// 	return onSnapshot(visitRef, snapshot => {
	// 		setVisitorsCount(snapshot.size);
	// 	});
	// }, [firestore]);
	// useEffect(() => {
	// 	const fetchVisits = async () => {
	// 		const visitRef = collection(firestore, 'visits');
	// 		const visitSnapshot = await getDocs(visitRef);
	// 		setVisitorsCount(visitSnapshot.size);
	// 	};

	// 	fetchVisits();
	// }, [firestore]);

	useEffect(() => {
		const img = new Image();
		img.src = '/assets/오프닝2.png';
		// const firstQuizImg = new Image();
		// firstQuizImg.src = '/assets/q2.webp';
		// const marketingImage = new Image();
		// marketingImage.src = '/assets/giftest_final.gif';
	}, []);

	const handleStartClick = () => {
		navigate('/'); // /quiz 경로로 이동
	};

	const handleStartClick2 = () => {
		navigate('/quiz2'); // /quiz 경로로 이동
	};

	return (
		<div className="start-container2">
			<Helmet>
				<meta property="og:site_name" content="루이바오 후이바오" />
				<meta
					property="og:image"
					content={`https://ruibao-huibao-test.web.app/assets/landing_page2.webp`}
				/>
				<meta property="og:title" content="루이바오 후이바오 테스트" />
				<meta
					property="og:description"
					content="문제를 맞추고 판다력을 확인하세요!"
				/>
				<meta property="og:type" content="website" />
				<meta
					property="og:url"
					content={`https://ruibao-huibao-test.web.app/v2`}
				/>
			</Helmet>
			<div className="contents">
				<div className="level">2탄</div>
				<div className="title">
					<div className="miniTitle">쌍둥이 판다 감별사</div>
					<div className="mainTitleWrap">
						<div className="mainTitle1">이 판다는 과연..</div>
						<div className="mainTitle2">루이일까? 후이일까?</div>
					</div>
				</div>
				<div className="imgBox">
					<img className="startImg" src="/assets/오프닝2.png" alt="" />
				</div>

				<button
					className="startButton"
					id="quizStartButton"
					onClick={handleStartClick2}
				>
					시작하기
				</button>
				<div className="participants-wrapper">
					<p className="participants-title">참여자 수</p>
					<p className="participants-text">
						{useCountUp(visitorsCount + 20231).toLocaleString()}
					</p>
				</div>

				<div className="goto-next" onClick={handleStartClick}>
					"루후테스트 1탄"에서 몸풀기 먼저하세요! 👉
				</div>
			</div>
		</div>
	);
};

export default StartPage2;
